import React from "react";
import BookingListProvider from "./Booking";
import ChatListProvider from "./ChatList";
import ErrorModalProvider from "./ErrorModal";
import ImageModalProvider from "./ImageModal";
import TagsStoreProvider from "./Tags";
import { SelectThemeProvider } from "./Theme";
import UserStoreProvider from "./UserStore";

const Providers: React.FC = ({ children }) => {
  return (
    <SelectThemeProvider>
      <ErrorModalProvider>
        <ImageModalProvider>
          <TagsStoreProvider>
            <UserStoreProvider>
              <BookingListProvider>
                <ChatListProvider>
                  <>{children}</>
                </ChatListProvider>
              </BookingListProvider>
            </UserStoreProvider>
          </TagsStoreProvider>
        </ImageModalProvider>
      </ErrorModalProvider>
    </SelectThemeProvider>
  );
};

export default Providers;
